import React, { useEffect, useState } from 'react';
import { getCurrentUserCompanyId } from './utils/userUtils';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import { hasPermission } from './utils/permissions';
import Banner from './components/Banner';

export default function Schedules() {
  const [schedules, setSchedules] = useState([]);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    async function load() {
      const ud = await (await import('./utils/userUtils')).getCurrentUserData();
      setUserData(ud);
      if (!hasPermission(ud, 'set_schedules')) return;
      const companyId = await getCurrentUserCompanyId();
      if (!companyId) return;
      const formsRef = collection(db, 'companies', companyId, 'forms');
      const formsSnap = await getDocs(formsRef);
      const allSchedules = [];
      for (const f of formsSnap.docs) {
        const schedulesRef = collection(db, 'companies', companyId, 'forms', f.id, 'schedules');
        const schedSnap = await getDocs(schedulesRef);
        schedSnap.forEach(s => allSchedules.push({ formId: f.id, formTitle: f.data().title, id: s.id, ...s.data() }));
      }
      setSchedules(allSchedules);
    }
    load();
  }, []);

  if (!userData) return null;
  if (!hasPermission(userData, 'set_schedules')) return (
    <div className="p-8">You do not have permission to view schedules.</div>
  );

  return (
    <div className="min-h-screen p-8">
      <div className="max-w-4xl mx-auto">
        <Banner className="mb-6 rounded-md" />
        <h1 className="text-2xl font-semibold mb-4">Schedules</h1>
        {schedules.length === 0 ? (
          <div className="p-4 bg-white rounded shadow">No schedules found.</div>
        ) : (
          <div className="space-y-3">
            {schedules.map(s => (
              <div key={s.id} className="p-4 bg-white rounded shadow-sm border">
                <div className="flex justify-between items-center">
                  <div>
                    <div className="font-semibold">{s.formTitle || s.formId}</div>
                    <div className="text-sm text-gray-500">{s.frequency || '—'}</div>
                  </div>
                  <div className="text-sm text-gray-600">Assigned: {s.assignedTo || '—'}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
